module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-google-maps/~/babel-runtime/core-js/object/set-prototype-of.js
// module id = 1095
// module chunks = 0